import { useEffect, useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import classnames from 'classnames';

import { stripePaymentIntentShape } from 'helpers/shared_types';
import { ReactComponent as CheckCircle } from '../../icons/check-circle.svg';
import './checkout_form.scss';

function formatStripeAmount(amount) {
  return (amount / 100).toFixed(2).toLocaleString();
}

const CheckoutForm = ({ paymentIntent }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [messageColor, setMessageColor] = useState('green');
  const [paymentSucceeded, setPaymentSucceeded] = useState(false);
  const [paymentProcessing, setPaymentProcessing] = useState(false);

  useEffect(() => {
    const hasChange = paymentIntent.charges?.total_count > 0;

    switch (paymentIntent.status) {
      case 'succeeded':
        setMessage('Payment succeeded!');
        setPaymentSucceeded(true);
        break;
      case 'processing':
        setMessage('Your payment is processing.');
        setPaymentProcessing(true);
        break;
      case 'requires_payment_method':
        hasChange &&
          setMessageColor('red') &&
          setMessage('Your payment was not successful, please try again.');
        break;
      default:
        setMessageColor('red');
        setMessage('Something went wrong.');
        break;
    }
  }, [paymentIntent.status, paymentIntent.charges]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${process.env.REACT_APP_URL}/checkout`,
      },
    });

    if (error?.type === 'card_error' || error?.type === 'validation_error') {
      setMessageColor('red');
      setMessage(error.message);
    } else {
      setMessageColor('red');
      setMessage('An unexpected error occurred.');
    }

    setIsLoading(false);
  };

  const messageClasses = classnames('tc pa5 f5', { [messageColor]: true });
  const terms = {
    auBecsDebit: 'never',
    bancontact: 'never',
    card: 'never',
    ideal: 'never',
    sepaDebit: 'never',
    sofort: 'never',
    usBankAccount: 'never',
  };

  const showMerci = paymentSucceeded || paymentProcessing;

  return (
    <div>
      <div className="logo-mobile img mw70 pl8 pb5  pt8 center ">
        <a
          href="https://sleepdoctor.fr"
          target="_blank"
          rel="noreferrer noopener"
        >
          <img src="/logo.png" alt="Sleep Doctor" className="svg" />
        </a>
      </div>
      {!showMerci && (
        <form className="payment-form" onSubmit={handleSubmit}>
          <PaymentElement options={{ terms }} />
          <div className="pt3">
            <span className="span-text">
              SleepDoctor n&apos;enregistre pas vos données de carte bancaire.
            </span>
          </div>

          <div className="h2" />
          <button
            disabled={isLoading || !stripe || !elements}
            id="submit"
            className="button-stripe"
          >
            <span id="button-text">
              {isLoading ? (
                <div className="ghost-spinner spinner-white"></div>
              ) : (
                `Payer €${formatStripeAmount(paymentIntent.amount)}`
              )}
            </span>
          </button>
          {message && <div className={messageClasses}>{message}</div>}
        </form>
      )}
      {showMerci && (
        <div className="flex flex-column">
          <CheckCircle className="h15 green" />
          <div className="f1 fw5 center pa5">Merci pour votre paiement</div>
          <div className="midgrey h3 center pa10">
            Un accusé de réception vous a été envoyé par e-mail.
          </div>
          <div className="h3 center pa5">
            <a href="mailto:support@sleepdoctor.me">support@sleepdoctor.me</a>
          </div>
          <div className="h3 center">
            <a href="tel:0189719040">01 89 71 90 40</a>
          </div>
        </div>
      )}
    </div>
  );
};

CheckoutForm.propTypes = {
  paymentIntent: stripePaymentIntentShape.isRequired,
};

export default CheckoutForm;
